import { IS_SERVER } from './checkRenderEnv';
import { AUTH_TOKEN } from './constants';

export const getAuthToken = () => {
  if (!IS_SERVER && localStorage?.getItem(AUTH_TOKEN)) {
    return localStorage?.getItem(AUTH_TOKEN);
  }
  return false;
};
